import { render, staticRenderFns } from "./GoodsReceipt.vue?vue&type=template&id=04bfecf0"
import script from "./GoodsReceipt.vue?vue&type=script&lang=js"
export * from "./GoodsReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports